/**
 * Ported from the lekterion codebase (`src/read/labels.ts`) @ `d942f2f`.
 * Bindery is canonical for this module from 2026-09-06; reconcile source-side
 * drift toward this copy.
 */
import type { Author, Lang, LocusSchemeId } from "@/lib/schemas/model";

/** Human labels for the model's enum codes (shared by the library + reader). */

export const LANG_LABEL: Record<Lang, string> = {
  de: "German",
  grc: "Greek",
  la: "Latin",
};

export const SCHEME_LABEL: Record<LocusSchemeId, string> = {
  "sz-niemeyer": "Niemeyer",
  ideen: "Ideen",
  "kant-AB": "KrV A/B",
  "kant-akademie": "Akademie",
  bekker: "Bekker",
  at: "Adam–Tannery",
};

/** Display order for the library, following the MVP corpus table. */
export const AUTHOR_ORDER: Author[] = [
  "Husserl",
  "Heidegger",
  "Kant",
  "Aristotle",
  "Descartes",
];
